export class DinneyAdminRequestDTO {
    
}